import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import Button from '../../common/Button';
import Switch from '../../common/Switch';
import ModalWindow from '../../common/Modal';
import SimpleCheckbox from '../../common/SimpleCheckbox';
import styles from './WarehousesModal.module.scss';

function WarehousesModal(props) {
  let [approved, setApproved] = useState(props.approved || []);
  let [allWarehouses, setAllWarehouses] = useState(props.approved == null);

  const closeModal = () => {
    setApproved([]);

    if (allWarehouses) {
      props.onClose(null);
    } else if (!approved.length) {
      props.onClose(false);
    } else {
      props.onClose(approved);
    }
  };

  const isChecked = (id) => approved.includes(id);

  const setChecked = (id, checked) => {
    if (checked) {
      setApproved(approved.concat(id));
    } else {
      setApproved(approved.filter((approvedId) => approvedId !== id));
    }
  };

  const enabledFormatter = (cell, row, rowIndex, { isChecked, setChecked }) => {
    const checked = isChecked(row.id);
    return <Switch onSwitch={(checked) => setChecked(row.id, checked)} checked={checked} />;
  };

  const columns = [
    {
      text: 'Id',
      dataField: 'id',
    },
    {
      text: 'Warehouse Name',
      dataField: 'name',
    },
    {
      text: 'Enabled?',
      dataField: 'enabled',
      formatter: enabledFormatter,
      isDummyField: true,
      formatExtraData: {
        isChecked,
        setChecked,
      },
    },
  ];

  return (
    <ModalWindow open={props.open} onClose={closeModal} showCloseIcon={false} center>
      <h2>{props.name} warehouses</h2>

      <hr />

      <div className={styles.body}>
        <SimpleCheckbox
          checked={allWarehouses}
          onChange={setAllWarehouses}
          value="all_warehouses"
          label="All Warehouses"
        />

        <div className={styles.table} hidden={allWarehouses}>
          <BootstrapTable
            data={props.warehouses}
            columns={columns}
            keyField="id"
            printable
            striped
            hover
            bordered={false}
            scrollTop="Top"
            className={styles.container}
          ></BootstrapTable>
        </div>
      </div>

      <hr />

      <div className={styles.footer}>
        <div className={styles.buttons}>
          <Button text="SAVE" onClick={closeModal} disabled={!allWarehouses && !approved.length} />
        </div>
      </div>
    </ModalWindow>
  );
}

export default WarehousesModal;

WarehousesModal.defaultProps = {
  open: false,
};

WarehousesModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  warehouses: PropTypes.arrayOf(PropTypes.object).isRequired,
  approved: PropTypes.arrayOf(PropTypes.number),
  name: PropTypes.string.isRequired,
};
